export class RichHelper {

    public static getIconUrl(n: string): string {
        return 'resources/icon/' + n + '_Icon_Texture.png';
    }
    public static makeIcon(n: string): { height: number, align: string, backgroundColor: { image: string } } {
        return { height: 40, align: 'center', backgroundColor: { image: RichHelper.getIconUrl(n) } };
    }

    public static getAllRichIcon(): any {
        return {
            default:RichHelper.makeIcon("a000_01"),
            a000_01: RichHelper.makeIcon("a000_01"),
            a001_01: RichHelper.makeIcon("a001_01"),
            a001_03: RichHelper.makeIcon("a001_03"),
            a002_01: RichHelper.makeIcon("a002_01"),
            a002_02: RichHelper.makeIcon("a002_02"),
            a003_01: RichHelper.makeIcon("a003_01"),
            a003_02: RichHelper.makeIcon("a003_02"),
            a004_03: RichHelper.makeIcon("a004_03"),
            a005_03: RichHelper.makeIcon("a005_03"),
            a006_03: RichHelper.makeIcon("a006_03"),
            a007_01: RichHelper.makeIcon("a007_01"),
            a007_03: RichHelper.makeIcon("a007_03"),
            a007_04: RichHelper.makeIcon("a007_04"),
            a009_03: RichHelper.makeIcon("a009_03"),
            b001_01: RichHelper.makeIcon("b001_01"),
            b001_03: RichHelper.makeIcon("b001_03"),
            b002_01: RichHelper.makeIcon("b002_01"),
            b002_02: RichHelper.makeIcon("b002_02"),
            b003_01: RichHelper.makeIcon("b003_01"),
            b003_02: RichHelper.makeIcon("b003_02"),
            b003_04: RichHelper.makeIcon("b003_04"),
            b004_01: RichHelper.makeIcon("b004_01"),
            b004_03: RichHelper.makeIcon("b004_03"),
            b005_03: RichHelper.makeIcon("b005_03"),
            b006_01: RichHelper.makeIcon("b006_01"),
            b006_03: RichHelper.makeIcon("b006_03"),
            b007_01: RichHelper.makeIcon("b007_01"),
            b007_03: RichHelper.makeIcon("b007_03"),            
            b008_01: RichHelper.makeIcon("b008_01"),
            b008_02: RichHelper.makeIcon("b008_02"),
            b010_03: RichHelper.makeIcon("b010_03"),
            c001_01: RichHelper.makeIcon("c001_01"),
            c001_03: RichHelper.makeIcon("c001_03"),
            c002_01: RichHelper.makeIcon("c002_01"),
            c002_03: RichHelper.makeIcon("c002_03"),
            c003_01: RichHelper.makeIcon("c003_01"),
            c004_01: RichHelper.makeIcon("c004_01"),
            c004_03: RichHelper.makeIcon("c004_03"),
            c004_04: RichHelper.makeIcon("c004_04"),
            c005_03: RichHelper.makeIcon("c005_03"),
            c007_01: RichHelper.makeIcon("c007_01"),
            c007_03: RichHelper.makeIcon("c007_03"),
            d001_01: RichHelper.makeIcon("d001_01"),
            d001_03: RichHelper.makeIcon("d001_03"),
            d002_01: RichHelper.makeIcon("d002_01"),
            d002_03: RichHelper.makeIcon("d002_03"),
            d002_04: RichHelper.makeIcon("d002_04"),
            d003_03: RichHelper.makeIcon("d003_03"),
            d005_03: RichHelper.makeIcon("d005_03"),
            d007_02: RichHelper.makeIcon("d007_02"),
            d008_03: RichHelper.makeIcon("d008_03"),
            d009_03: RichHelper.makeIcon("d009_03"),
            d010_02: RichHelper.makeIcon("d010_02"),
            da03_01: RichHelper.makeIcon("da03_01"),
            da04_01: RichHelper.makeIcon("da04_01"),
            e001_01: RichHelper.makeIcon("e001_01"),
            e001_04: RichHelper.makeIcon("e001_04"),
            e002_01: RichHelper.makeIcon("e002_01"),
            e002_03: RichHelper.makeIcon("e002_03"),
            e002_04: RichHelper.makeIcon("e002_04"),
            e003_01: RichHelper.makeIcon("e003_01"),
            e003_03: RichHelper.makeIcon("e003_03"),
            e004_01: RichHelper.makeIcon("e004_01"),
            e004_02: RichHelper.makeIcon("e004_02"),
            e005_03: RichHelper.makeIcon("e005_03"),
            e007_01: RichHelper.makeIcon("e007_01"),
            e007_02: RichHelper.makeIcon("e007_02"),
            e007_04: RichHelper.makeIcon("e007_04"),
            e008_03: RichHelper.makeIcon("e008_03"),
            e009_01: RichHelper.makeIcon("e009_01"),
            ea01_01: RichHelper.makeIcon("ea01_01"),
            ea03_01: RichHelper.makeIcon("ea03_01"),
            f001_01: RichHelper.makeIcon("f001_01"),
            f001_03: RichHelper.makeIcon("f001_03"),
            f002_01: RichHelper.makeIcon("f002_01"),
            f002_03: RichHelper.makeIcon("f002_03"),
            f003_01: RichHelper.makeIcon("f003_01"),
            f003_03: RichHelper.makeIcon("f003_03"),
            f004_03: RichHelper.makeIcon("f004_03"),
            f005_01: RichHelper.makeIcon("f005_01"),
            f005_02: RichHelper.makeIcon("f005_02"),
            f006_01: RichHelper.makeIcon("f006_01"),
            f006_03: RichHelper.makeIcon("f006_03"),
            f007_01: RichHelper.makeIcon("f007_01"),
            f007_02: RichHelper.makeIcon("f007_02"),
            f008_02: RichHelper.makeIcon("f008_02"),
            f008_03: RichHelper.makeIcon("f008_03"),
            fi04_01: RichHelper.makeIcon("fi04_01"),
            g025_01: RichHelper.makeIcon("g025_01"),
            mb05_1:RichHelper.makeIcon("mb05_1"),
            wa04_01: RichHelper.makeIcon("wa04_01"),

        };
    }
}